// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"6a71c765","798":"ee6c5929","956":"448127d1"}[chunkId] + ".chunk.js";
};